module.exports = __webpack_public_path__ + "img/icon-menu-progress.2225c131.svg";